import { render, staticRenderFns } from "./ModalPendenciaAdministrativa.vue?vue&type=template&id=79403785&scoped=true"
import script from "./ModalPendenciaAdministrativa.vue?vue&type=script&lang=ts"
export * from "./ModalPendenciaAdministrativa.vue?vue&type=script&lang=ts"
import style0 from "./ModalPendenciaAdministrativa.vue?vue&type=style&index=0&id=79403785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79403785",
  null
  
)

export default component.exports